<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2024-07-04 17:08:28
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-07-04 17:12:59
-->
<template>
  <div class="angio-pdf">
    <!-- <div class="mark"></div> -->
    <iframe ref="iframe" id="iframe" :src="pdfUrl" frameborder="0" scrolling="no" class="pdf-iframe"></iframe>
  </div>
</template>

<script>
// import { base64toBlobUrl } from '@/utils/common'
export default {
  data () {
    return {
      id: '',
      pdfUrl: 'https://www.arteryflow.com/file/test/a.pdf#toolbar=0'
      // pdfUrl: '', // pdf文件地址
    }
  },
  mounted () {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.getAngioPdf()
    document.oncontextmenu = function () {
      return false
    }
    // this.$nextTick(() => {
    //   console.log(this.$refs.iframe.contentWindow)
    //   console.log(this.$refs.iframe.contentDocument)
    //   // this.$refs.iframe.contentWindow.document.oncontextmenu = function () {
    //   //   console.log('111')
    //   //   return false
    //   // }
    //   console.log(this.$refs.iframe.getElementsByTagName('body'))
    //   console.log(this.$refs.iframe.contentWindow.document.getElementsByTagName('body')[0])
    //   this.$refs.iframe.contentWindow.document.getElementsByTagName('body')[0].oncontextmenu = function () {
    //     console.log('22')
    //     return false
    //   }
    //   console.log(this.$refs.iframe.contentWindow.document.oncontextmenu)
    //   // console.log(this.$refs.iframe.getElementsByTagName('embed'))
    //   // this.$refs.iframe.getElementsByTagName('embed')[0].contentWindow.document.oncontextmenu = function () {
    //   //   console.log('111')
    //   //   return false
    //   // }
    //   // console.log(this.$refs.iframe.getElementsByTagName('embed')[0].contentWindow.document.oncontextmenu)
    // })
  },
  methods: {
    getAngioPdf () {
      const parms = {
        // id: 'a822549bfc7b48f9922e5e004279db2a'
        id: this.id
      }
      this.$store.dispatch('app/getAngioPdf', parms).then((res) => {
        // console.log(res)
        // console.log(base64toBlobUrl(res))
        // this.pdfUrl = `data:application/pdf;base64,${res}`
        // this.pdfUrl = base64toBlobUrl(res)
        this.pdfUrl = 'data:application/pdf;base64,' + res
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.angio-pdf {
  height: 100vh;
  width: 100%;
  position: relative;
}
.mark {
  position: absolute;
  top: 0;
  left: 0;
  right: 10PX;
  bottom: 0PX;
}
.pdf-iframe {
  height: calc(100vh - 10PX);
  width: 100%;
}
</style>
